define.alias("ember-basic-dropdown/modifiers/basic-dropdown-trigger", "settings/modifiers/basic-dropdown-trigger");